var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-flex',{staticClass:"navs",class:[_vm.theme],attrs:{"row":"","j-center":"","a-center":""}},_vm._l((_vm.navs),function(item){return _c('HeaderNavItem',{key:item.key,staticClass:"item",attrs:{"to":item.to,"title":item.title,"icon":item.icon,"action":item.action},on:{"action":_vm.handleAction}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }